// The starter questions the empty assistant panel offers as chips (MOTHER-191), chosen by
// the page. Pure: no React, no fetch, so it is unit tested (suggestions.test.ts). The
// wording is fixed here, not generated: sentence case, each under 60 characters.
import type { ObjectKey } from '../navigation';

import { viewingFrom } from './viewing';

/** On a page that is not a record page. */
export const GENERAL_SUGGESTIONS: readonly string[] = [
  'What is in my pipeline closing this month?',
  'What did I work on yesterday?',
  'How many hours have I logged this week?',
];

/** On a record page, by object; an object not named here offers none. */
export const RECORD_SUGGESTIONS: Partial<Record<ObjectKey, readonly string[]>> = {
  accounts: ['Summarise this account', 'Which deals does this account have open?', 'Who are the contacts at this account?'],
  contacts: ['Summarise this contact', 'What has happened with this contact?', 'Which account is this contact at?'],
  leads: ['Summarise this lead', 'What has happened with this lead?'],
  opportunities: ['Summarise this deal', 'What has happened on this deal?', 'Who is staffed on this deal?'],
  projects: ['What work is open or overdue on this project?', 'What has happened on this project?'],
};

/**
 * The chips for the page at `pathname`, at most three: on a record page (viewingFrom, so
 * its related lists too) those for its object, or none for an object without any; on
 * every other page the general ones. A fresh array each call, so a caller may keep it.
 */
export function suggestionsFor(pathname: string): string[] {
  const viewing = viewingFrom(pathname);
  if (viewing === null) return [...GENERAL_SUGGESTIONS];
  return [...(RECORD_SUGGESTIONS[viewing.object] ?? [])];
}
